import { render, staticRenderFns } from "./copyTransfer.vue?vue&type=template&id=034d7bb1"
import script from "./copyTransfer.vue?vue&type=script&lang=js"
export * from "./copyTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports